import api from './api'
let service = {}

service.login = function(user, pass){
    return api.post('/login', {user,pass}).then(res => res.data)
}

export default service